import { scales } from "plotly.js/src/components/colorscale";
import chroma from "chroma-js";
const plotlyScaleToChroma = (plotlyScale) => {
  const domains = plotlyScale.map(([domain]) => domain);
  const colors = plotlyScale.map(([, color]) => color);
  return chroma.scale(colors).domain(domains);
};
const scaleForGradient = (gradient) => {
  switch (gradient) {
    case "Blackbody":
    case "Bluered":
    case "Cividis":
    case "Earth":
    case "Electric":
    case "Hot":
    case "Jet":
    case "Picnic":
    case "Portland":
    case "Rainbow":
      return plotlyScaleToChroma(scales[gradient]);
    default:
      return chroma.scale(gradient);
  }
};
export default scaleForGradient;
